import LoyaltyNudgerSFC from "./LoyaltyNudger.vue";
export const LoyaltyNudger = LoyaltyNudgerSFC;
